import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { buildSelectedItems } from './utils';
import { IObject } from 'types';
import { AddressItem } from './components';
import { Wrapper } from './fias-addresses-list.styled';

interface IProps {
  /** Группы домов (`fias.selectedGroups`) */
  selectedGroups?: IObject[];
  /** Улицы, посёлки, города и другие объекты (`fias.selectedFias`) */
  selectedFias?: IObject[];
  /** Дома (`fias.selectedHouses`) */
  selectedHouses?: IObject[];
  isDisabled?: boolean;
  /** Пустой блок на месте шеврона у групп домов (см. AddressItem). */
  withEmptyIcon?: boolean;
}

// Стабильная ссылка, чтобы пустой массив по умолчанию не сбрасывал useMemo
const EMPTY: IObject[] = [];

export const FiasAddressesList = observer(
  ({
    selectedGroups = EMPTY,
    selectedFias = EMPTY,
    selectedHouses = EMPTY,
    isDisabled,
    withEmptyIcon,
  }: IProps) => {
    const { fias } = useStore();

    const items = useMemo(
      () =>
        buildSelectedItems(
          {
            groups: selectedGroups,
            fias: selectedFias,
            houses: selectedHouses,
          },
          fias.tree
        ),
      [selectedGroups, selectedFias, selectedHouses, fias.tree]
    );

    return (
      <>
        {!!items.length && (
          <Wrapper isDisabled={isDisabled}>
            {items.map((item: IObject, index: number) => (
              <AddressItem
                key={index}
                item={item}
                withEmptyIcon={withEmptyIcon}
              />
            ))}
          </Wrapper>
        )}
      </>
    );
  }
);
